import { ScoreUtil } from 'common/utils/scoreUtil';
import format from 'date-fns/format';

/**
 * @desciprtion 선택된 탭 조건에 의해 리스트 필터
 * @param {*} selectedTab
 * @param {*} sportsTypeKeyArr
 * @param {*} sportsView
 * @returns
 */
function getFilterList(selectedTab, sportsTypeKeyArr, sportsView) {
  let filterList = {
    soccer: [],
    baseball: [],
    basketball: [],
    volleyball: [],
    hockey: [],
    football: []
  };

  if (selectedTab === 'ALL') {
    sportsTypeKeyArr.forEach((key) => {
      filterList[key] = [
        ...sportsView[key]
      ];
    });
  } else {
    sportsTypeKeyArr.forEach((key) => {
      filterList[key] = [
        ...sportsView[key].filter((item) => {
          if (selectedTab === 'READY') {
            return item.gameStatus === 'READY';
          } else if (selectedTab === 'PROGRESS') {
            return (
              item.gameStatus === 'IN_PROGRESS' ||
              item.gameStatus === 'BREAK_TIME' ||
              item.gameStatus === 'PAUSE'
            );
          } else if (selectedTab === 'FINAL') {
            return (
              item.gameStatus === 'FINAL' ||
              item.gameStatus === 'CUT' ||
              item.gameStatus === 'POSTPONED' ||
              item.gameStatus === 'PENDING' ||
              item.gameStatus === 'CANCEL' ||
              item.gameStatus === 'DELAY' ||
              item.gameStatus === 'SUSPENDED'
            );
          }
        })
      ];
    });
  }

  return filterList;
}

/**
 * @desciprtion 선택된 탭 조건에 의해 리스트 필터
 * @param {*} selectedTab
 * @param {*} sportsTypeKeyArr
 * @param {*} sportsView
 * @returns
 */
function getFilterDeleteFinalList(selectedTab, sportsTypeKeyArr, sportsView) {
  let filterList = {
    soccer: [],
    baseball: [],
    basketball: [],
    volleyball: [],
    hockey: [],
    football: []
  };

  if (selectedTab === 'ALL') {
    // ALL 일때 종료경기 빠짐
    sportsTypeKeyArr.forEach((key) => {
      filterList[key] = [
        ...sportsView[key].filter((item) => {
          if (
            item.gameStatus === 'READY' ||
            item.gameStatus === 'IN_PROGRESS' ||
            item.gameStatus === 'BREAK_TIME' ||
            item.gameStatus === 'PAUSE'
          ) {
            return item;
          }
        })
      ];
    });
  } else {
    sportsTypeKeyArr.forEach((key) => {
      filterList[key] = [
        ...sportsView[key].filter((item) => {
          if (selectedTab === 'READY') {
            return item.gameStatus === 'READY';
          } else if (selectedTab === 'PROGRESS') {
            return (
              item.gameStatus === 'IN_PROGRESS' ||
              item.gameStatus === 'BREAK_TIME' ||
              item.gameStatus === 'PAUSE'
            );
          } else if (selectedTab === 'FINAL') {
            return (
              item.gameStatus === 'FINAL' ||
              item.gameStatus === 'CUT' ||
              item.gameStatus === 'POSTPONED' ||
              item.gameStatus === 'PENDING' ||
              item.gameStatus === 'CANCEL' ||
              item.gameStatus === 'DELAY' ||
              item.gameStatus === 'SUSPENDED'
            );
          }
        })
      ];
    });
  }

  return filterList;
}

/**
 * @description 선택된경기 삭제
 * @param {*} sportsTypeKeyArr
 * @param {*} filterList
 * @param {*} selectedGames
 * @returns
 */
function getDeletedGames(sportsTypeKeyArr, filterList, selectedGames) {
  let deleteSelectedGames = {};

  sportsTypeKeyArr.forEach((key) => {
    let keyData = filterList[key];

    if (selectedGames.length > 0) {
      keyData = filterList[key].filter((item) => {
        return selectedGames
          .filter((f) => f.sportsType === key)
          .every((id) => item.id !== id.key);
      });
    }

    deleteSelectedGames[key] = ScoreUtil.sortSportsList(keyData);
  });

  return deleteSelectedGames;
}

/**
 * @description Object를 list로 변경
 * @param {*} deleteSelectedGames
 * @returns
 */
function getConcatList(deleteSelectedGames) {
  let result = [];

  Object.keys(deleteSelectedGames).forEach((key) => {
    result = [...result, ...deleteSelectedGames[key]];
  });

  return ScoreUtil.sortSportsList(result);
}

/**
 * @description 디자인 변경으로 사용 안함 HH 로 같은 경기를 묶음
 * @param {*} list
 * @returns
 */
// function setTimeView(list) {
//   let result = new Map();

//   list.reduce(
//     (acc, cur) => {
//       const hour = format(new Date(cur.startDatetime + '+09:00'), 'HH');
//       const arr = [cur];

//       if (!!acc.time) {
//         if (acc.time === hour) {
//           acc.result.set(hour, [...acc.result.get(hour), ...arr]);

//           return acc;
//         } else {
//           acc.time = hour;
//           acc.result.set(hour, arr);

//           return acc;
//         }
//       } else {
//         acc.time = hour;
//         acc.result.set(hour, arr);

//         return acc;
//       }
//     },
//     { time: null, result }
//   );

//   return result;
// }

/**
 * @description 시간 + 리그로 묶음
 * @param {*} list
 * @returns
 */
function setDefaultList(list) {
  let result = new Map();

  list.reduce(
    (acc, cur, idx) => {
      const hourMinute = format(
        new Date(cur.startDatetime + '+09:00'),
        'dd-HH-mm'
      );
      const arr = [cur];

      if (!!acc.time) {
        const prevData = acc.result.get(acc.lastIdx);

        if (!!prevData) {
          let mapKey = idx;
          let list = arr;

          if (acc.time === hourMinute && prevData.league.id === cur.league.id) {
            mapKey = acc.lastIdx;
            list = [...prevData.list, ...arr];
          }

          acc.time = hourMinute;
          acc.result.set(mapKey, {
            league: cur.league,
            sportsType: cur.sportsType,
            list
          });
          acc.lastIdx = mapKey;

          return acc;
        } else {
          acc.time = hourMinute;
          acc.result.set(idx, {
            league: cur.league,
            sportsType: cur.sportsType,
            list: arr
          });
          acc.lastIdx = idx;

          return acc;
        }
      } else {
        acc.time = hourMinute;
        acc.result.set(idx, {
          league: cur.league,
          sportsType: cur.sportsType,
          list: arr
        });
        acc.lastIdx = idx;

        return acc;
      }
    },
    { time: null, lastIdx: 0, result }
  );

  return result;
}

export { getFilterList, getDeletedGames, getConcatList, setDefaultList, getFilterDeleteFinalList };
